import { useReturnRegister } from "@/data/Content/RegisterReturn";
import { ContentContext } from "@/data/context/content";
import { useLocalization } from "@/data/Localization";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { ContentRecommendation } from "../../ContentRecommendation";
import { RegisterReturnAddressCheckForm } from "@/data/types/ReturnOrder";
import { ReturnOrderFormContainerSX } from "../styles/returnOrder";

export const DownloadReturnOrder: FC = () => {
    const returnOrderNLS = useLocalization('ReturnOrder');
    const {
        downloadReturnLabel,
        setReturnAddressValues
    } = useContext(ContentContext) as ReturnType<typeof useReturnRegister>;

    useEffect(()=>{
        setReturnAddressValues({} as RegisterReturnAddressCheckForm); // Reset user entered address values as return process is complete on load of this component
    },[]);

    return (
        <Paper sx={ReturnOrderFormContainerSX}>
            <Stack mb={1}>
                <Typography variant="body1AsH1" fontSize={16} fontWeight='bold'>
                    {returnOrderNLS.DownloadForm.thanksForReturn.t()}
                </Typography>
            </Stack>
            <Stack mb={1}>
                <Typography variant="body1AsH1" fontSize={16} fontWeight='bold'>
                    {returnOrderNLS.DownloadForm.ReturnOrderNextSteps.t()}
                </Typography>
            </Stack>
            <Stack spacing={2}>
                <Stack spacing={1}>
                    <ContentRecommendation
                        id='Return_Order_Complete_Next_Step_1_espot'
                        properties={{emsName:'Return_Order_Complete_Next_Step_1_espot'}}
                    />
                    <ContentRecommendation
                        id='Return_Order_Complete_Next_Step_2_espot'
                        properties={{emsName:'Return_Order_Complete_Next_Step_2_espot'}}
                    />
                </Stack>
                <Stack>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Button
                                data-testid="download-return-label-button"
                                id="download-return-label-button"
                                type="submit"
                                variant="contained"
                                onClick={downloadReturnLabel}
                                fullWidth
                            >
                                {returnOrderNLS.Labels.Download.t()}
                            </Button>
                        </Grid>
                    </Grid>
                </Stack>
                <Stack spacing={1}>
                    <ContentRecommendation
                        id='Return_Order_Complete_Next_Step_3_espot'
                        properties={{emsName:'Return_Order_Complete_Next_Step_3_espot'}}
                    />
                    <ContentRecommendation
                        id='Return_Order_Complete_Next_Step_4_espot'
                        properties={{emsName:'Return_Order_Complete_Next_Step_4_espot'}}
                    />
                </Stack>
            </Stack>
        </Paper>
    );
};